import routers, {buildPath} from '@/config/routers';
import {getKnowledgePageRouteMatchInfo} from '@/utils/urlUtils';
import {useEffect} from 'react';

const FORBIDDEN_CONF = {
    'lFWdGgorG5': '晋升管理系统',
    '1_qiHKa0st': '同学圈安利活动管理',
    'erApToPABb': '知一学堂线上课件管理',
    'Ic0vF-2Xu7': 'PCC评审资料管理系统',
    'Zp5Qh4Hkbq': '知识库论坛助手',
};

export const getIsHiddenRepo = (repositoryGuid: string) => {
    let result = null;
    Object.keys(FORBIDDEN_CONF).forEach((key) => {
        if (key === repositoryGuid) {
            // @ts-ignore
            result = FORBIDDEN_CONF[key];
        }
    });
    return result;
};

export const useHiddenRepo = () => {
    const {
        repositoryGuid,
    } = getKnowledgePageRouteMatchInfo();

    const isHiddenRepo = !!getIsHiddenRepo(repositoryGuid);

    useEffect(() => {
        if (isHiddenRepo) {
            location.href = buildPath(routers.HiddenRepo, {
                repositoryGuid,
            });
        }
    }, [isHiddenRepo, repositoryGuid]);
};
